// Этот файл генерируется автоматически, его не следует редактировать вручную
import form from '@/widgets/form.js';
import headerBlock from '@/widgets/headerBlock.js';
import mobileMenu from '@/widgets/mobileMenu.js';
import mobileMenuButton from '@/widgets/mobileMenuButton.js';
import openPopupForm from '@/widgets/openPopupForm.js';
import sliderClients from '@/widgets/sliderClients.js';
import sliderProducts from '@/widgets/sliderProducts.js';
import sliderServices from '@/widgets/sliderServices.js';

export default {
  'form': async () => { return { default: form }; },
  'formPopup': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/formPopup.js'),
  'headerBlock': async () => { return { default: headerBlock }; },
  'mobileMenu': async () => { return { default: mobileMenu }; },
  'mobileMenuButton': async () => { return { default: mobileMenuButton }; },
  'openPopupForm': async () => { return { default: openPopupForm }; },
  'scrollTop': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollTop.js'),
  'sliderClients': async () => { return { default: sliderClients }; },
  'sliderProducts': async () => { return { default: sliderProducts }; },
  'sliderServices': async () => { return { default: sliderServices }; },
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js')
};
